import CircularProgressBar from 'admin/components/atoms/CircularProgressBar';
import React from 'react';
import styled from 'styled-components';
import { PayspotDetailsCard, PayspotDetailsCardTitle } from '../PayspotDetailsCard';

const progressColors = {
  default: '#00a23f',
  warning: '#ff9f00',
  danger: '#ff3f34',
};

const CapacityWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 8px;
`;

const UsedCapacityCard = ({ percentage }) => {
  const progressColor =
    percentage > 80
      ? progressColors.danger
      : percentage > 50
      ? progressColors.warning
      : progressColors.default;

  return (
    <PayspotDetailsCard>
      <PayspotDetailsCardTitle>金庫使用量</PayspotDetailsCardTitle>
      <CapacityWrapper>
        <CircularProgressBar
          radius={65}
          percentage={Number.isNaN(percentage) ? 0 : percentage}
          color={progressColor}
          textSize={20}
        />
      </CapacityWrapper>
    </PayspotDetailsCard>
  );
};

export default UsedCapacityCard;
